/* ═══════════════════════════════════════════════
   APEX PERSONAL — Theme JavaScript
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ─── Scroll Reveal with stagger ─── */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const delay = el.dataset.delay || 0;
          setTimeout(() => el.classList.add('visible'), delay);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.05 });
    reveals.forEach((el, i) => {
      if (!el.dataset.delay) el.dataset.delay = i * 80;
      observer.observe(el);
    });
  }


  /* ─── Smooth scroll for anchor links ─── */
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });


  /* ─── Mobile nav toggle ─── */
  const toggle = document.querySelector('.mobile-nav-toggle');
  const nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('open');
      nav.classList.toggle('site-nav--open');
      document.body.style.overflow = nav.classList.contains('site-nav--open') ? 'hidden' : '';
    });
  }


  /* ─── Hide header on scroll down, show on scroll up (desktop only) ─── */
  const header = document.querySelector('.section-header');
  if (header) {
    let lastScroll = 0;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (window.innerWidth <= 640) return;
      if (!ticking) {
        requestAnimationFrame(() => {
          const y = window.scrollY;
          if (y > lastScroll && y > 80) {
            header.classList.add('header--hidden');
          } else {
            header.classList.remove('header--hidden');
          }
          lastScroll = y;
          ticking = false;
        });
        ticking = true;
      }
    });
  }


  /* ─── Parallax float on hero portrait ─── */
  const heroVisual = document.querySelector('.hero__visual');
  if (heroVisual && window.innerWidth > 960) {
    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        const y = window.scrollY * 0.04;
        heroVisual.style.transform = `translateY(${y}px)`;
      });
    });
  }


  /* ─── Shopify editor: reveal sections on reload ─── */
  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('.reveal').forEach(el => {
      el.classList.add('visible');
    });
  });

});
